import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";


export const TeamAPI = async (setTeams, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/teams?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setTeams(response.data.data.data);
        setLoading(false);

        if(response.data.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const InviteTeamAPI = async (params, setIsTeamAdd, setShowPopup, setShowInviteSpinner) =>
{    

    setShowInviteSpinner(true);

    try 
    {
        const response = await baseapi.post('api/sales/team/invite', params);

        //console.log("Data got successfully", response.data.mesg);

        setShowPopup(false);

        setShowInviteSpinner(false);
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            setIsTeamAdd(true);
        }
        else
        {
            errorMesg(response.data.mesg);
        }

    } 
    catch (error) 
    {
        console.error("Error in caller invite:", error);
        //setLoading(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    }

}

export const DeleteTeamAPI = async (teamid, setIsTeamDelete, setShowDeletePopup, setShowDeleteSpinner) =>
{
    setShowDeleteSpinner(true);

    try 
    {
        const response = await baseapi.get("/api/sales/team/delete/" + teamid);

        //console.log("Data got successfully", response);

        setShowDeletePopup(false);

        setShowDeleteSpinner(false);
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            setIsTeamDelete(true);
        }
        else
        {
            errorMesg(response.data.mesg);
        }

    } 
    catch (error) 
    {
        console.error("Error in caller invite:", error);
        //setLoading(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    }

}


